/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-session-timeout-modal-window',
  templateUrl: './session-timeout-modal-window.component.html'
})
export class SessionTimeoutModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<SessionTimeoutModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) {
  }

  onClose(value: string) {
    this.dialogRef.close(value);
  }
}
